import { PublicSearchResponse } from '@ahora-patagonia/contracts';
import type { ApiClient } from '../../../shared/http/ApiClient.js';
import { fixtureBusqueda, fixturesActivos } from '../../../shared/fixtures/publicFixtures.js';
import type { BusquedaData } from '../entities/BusquedaData.js';

/** Búsqueda por título, insensible a acentos (la normalización vive en la API). */
export class BusquedaRepository {
  constructor(private readonly api: ApiClient) {}

  async buscar(q: string, page = 1): Promise<BusquedaData> {
    const fixtures = fixturesActivos();
    if (fixtures) return fixtureBusqueda(q, fixtures);
    const data = await this.api.get<unknown>(
      `/public/search?q=${encodeURIComponent(q)}&page=${page}`,
    );
    return PublicSearchResponse.parse(data);
  }
}
